/**
 * Who may delete a post (release rule, 2026-10-21; the API enforces the same rule):
 * - admin: any post;
 * - umbrella (umbrella admin): any post it can open, i.e. of the projects under its umbrella;
 * - charity (charity admin and charity volunteer) and volunteer: only posts they created,
 *   matched on the post's creator.id against the token's sub (authProvider.getIdentity().id).
 */
const canDeletePost = (role, record, userId) => {
    if (!record) return false;
    if (role === 'admin' || role === 'umbrella') return true;
    if (role === 'charity' || role === 'volunteer') {
        const creatorId = record.creator?.id;
        return Boolean(userId) && creatorId != null && String(creatorId) === String(userId);
    }
    return false;
};

export default canDeletePost;
